// extracted by mini-css-extract-plugin
module.exports = {"cover":"whyWeDoIt_cover__ex0FO","image":"whyWeDoIt_image__1bxYz","capitals":"whyWeDoIt_capitals__12_xY","title":"whyWeDoIt_title__n79MY"};